/**
 * Whether the app runs in a store app (Capacitor, ios/ and android/) rather
 * than in a browser. Copied from Empilo (memoneoapp/empilo-app,
 * src/native/), kept free of the rest of Chouette: this folder is meant to
 * move to the shared memoneo mobile kit (docs/stores.md).
 */
import { Capacitor } from "@capacitor/core";

export const isNative = (): boolean => Capacitor.isNativePlatform();

/** The web origin the app stands for. In a browser, where it runs; in a store
 *  app, the site (VITE_PUBLIC_ORIGIN), never capacitor://app.memoneo.chouette:
 *  links built from it (the magic link, a shared story) must open the site
 *  or the app. */
export function publicOrigin(): string {
  if (isNative() && import.meta.env.VITE_PUBLIC_ORIGIN) return import.meta.env.VITE_PUBLIC_ORIGIN;
  return window.location.origin;
}
